module.exports = __webpack_public_path__ + "static/media/bolt background.0681d14f.svg";